module.exports = __webpack_public_path__ + "static/media/slider-10.d1dbfeb3.jpg";